// API service for pairing operations

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const pairingService = {
  /**
   * Exchange pairing code for pair token
   * POST /auth/pairDevice
   */
  async pairDevice(pairingCode) {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/pairDevice`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: parseInt(pairingCode)
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to pair device');
      }

      return {
        success: true,
        data: {
          pairToken: data.pairToken,
          message: data.message,
          user: data.user
        }
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  },

  /**
   * Validate existing pair token
   * POST /auth/validatePairToken
   */
  async validatePairToken(pairToken) {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/validatePairToken`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          pairToken
        })
      });

      return response.ok;
    } catch (error) {
      console.error('Token validation failed:', error);
      return false;
    }
  }
};
